import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 1850 1850" {...props}>
      <defs>
        <linearGradient id="a" x1="375.132" x2="710.738" y1="1491.484" y2="292.492" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="black" />
          <stop offset="1" stop-color="black" />
        </linearGradient>
      </defs>
      <path d="M1123.874 33.793C1011.738-30.948 857.56 26.16 779.511 161.346l-537.205 931.456c-78.049 135.186-50.417 297.262 61.718 362.003 112.135 64.741 266.313 7.633 344.363-127.552l537.204-931.457c78.05-135.185 50.418-297.261-61.717-362.003Z" />
      <defs>
        <linearGradient id="b" x1="260.619" x2="581.423" y1="790.436" y2="341.574" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="black" />
          <stop offset="1" stop-color="black" />
        </linearGradient>
      </defs>
      <path d="M109.024 33.793C-3.111 98.535-30.743 260.611 47.306 395.796L615 1376s9.135-10.341 22-30c6.054-9.251 12.462-21.557 20-34 20.89-34.482 45.213-79.869 73-127 75.245-127.629 157.657-271.477 157.657-271.477l-434.27-752.177C375.337 26.16 221.159-30.948 109.024 33.793Z" />
      <defs>
        <linearGradient id="c" x1="782.538" x2="1543.656" y1="809.459" y2="202.563" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-opacity=".291" /><stop offset="1" stop-color="black" />
        </linearGradient>
      </defs>
      <path d="M872 58c-22.196 12.815-60.266 52.169-81 84-13.256 20.351-23.551 40.464-32 54-61.659 98.783-61.717 242.542 10.367 367.396L928 839l58-97 193 178c97.411 168.721 239 138 239 138 139.952-80.801 267.998-72.897 170.587-241.618l-312.405-545.596C1178.771 102.065 1011.952-22.801 872 58Z" />
      <defs>
        <linearGradient id="d" x1="984.908" x2="1421.61" y1="764.698" y2="363.078" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="black" />
          <stop offset=".204" stop-color="black" />
          <stop offset=".584" stop-color="black" />
          <stop offset="1" stop-color="black" />
        </linearGradient>
      </defs>
      <path d="M899.395 36.592c-139.952 80.801-174.439 283.083-77.028 451.804l312.404 545.596c97.411 168.721 289.836 239.995 429.788 159.194 139.952-80.802 174.439-283.083 77.028-451.804l-312.405-545.596C1231.771 27.065 1039.347-44.21 899.395 36.592Z" />
    </Svg>
  );
};

export default Icon;
